import { render, staticRenderFns } from "./EditarTipoDocumento.vue?vue&type=template&id=0825d2f5&scoped=true"
import script from "./EditarTipoDocumento.vue?vue&type=script&lang=js"
export * from "./EditarTipoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825d2f5",
  null
  
)

export default component.exports